<template>
  <v-list dense class="elevation-1">
    <v-subheader>Administracion</v-subheader>
    <v-list-tile @click="goTo(item.link)" v-for="item in menu" :key="item.id">
      <v-list-tile-action>
        <v-icon color="info" small>{{item.icono}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title v-text="item.titulo"></v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider></v-divider>
    <v-subheader>Seguridad</v-subheader>
    <v-list-tile @click="goTo(item.link)" v-for="item in menuAdmin" :key="item.id">
      <v-list-tile-action>
        <v-icon color="yellow darken-4" small>{{item.icono}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title v-text="item.titulo"></v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>

</template>

<script>

export default {
  name: 'Menu',
  data () {
    return {
      menu: [
        { id: 1, titulo: 'Dashboard', link: '/', icono: 'fas fa-tachometer-alt' },
        { id: 2, titulo: 'Carriers', link: '/carriers', icono: 'fas fa-mobile-alt' },
        { id: 3, titulo: 'Clientes', link: '/clientes', icono: 'fas fa-briefcase' },
        { id: 4, titulo: 'Comandos', link: '/comandos', icono: 'fas fa-terminal' },
        { id: 5, titulo: 'Servidores', link: '/servidores', icono: 'fas fa-server' },
        { id: 6, titulo: 'Tracks', link: '/tracks', icono: 'fas fa-map-marker-alt' },
        { id: 7, titulo: 'Vehiculos', link: '/vehiculos', icono: 'fas fa-car' },
      ],
      menuAdmin: [
        { id: 100, titulo: 'Usuarios', link: '/usuarios', icono: 'fas fa-users' },
        { id: 101, titulo: 'Grupos', link: '/grupos', icono: 'fas fa-object-group' },
      ]
    }
  },
  methods: {
    goTo(to) {
      this.$router.push(to)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue